import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=a8045796&scoped=true"
var script = {}
import style0 from "@/assets/css/contents03.css?vue&type=style&index=0&id=a8045796&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8045796",
  null
  
)

export default component.exports